import { useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { Create } from '@refinedev/antd';
import { useEffect } from 'react';

const TextArea  = Input;

export const BranchCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: "branch",
    meta: {
      fields: ["name", "code", "address", "phoneNumber", "email", "isActive"]
    }
  });

  useEffect(() => {
    console.log("BranchCreate - Form initialized");
  }, []);

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true }]}
        >
          <Input id="name" />
        </Form.Item>

        <Form.Item
          label="Code"
          name="code"
          rules={[{ required: true }]}
        >
          <Input id="code" />
        </Form.Item>

        <Form.Item
          label="Address"
          name="address"
          rules={[{ required: true }]}
        >
          <TextArea id="address" rows={4} />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phoneNumber"
        >
          <Input id="phoneNumber" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
        >
          <Input id="email" />
        </Form.Item>
      </Form>
    </Create>
  );
};